export const image = {
    logo: require('./image/Logo.png'),
    bg: require('./image/bg.jpg'),
    dashboard: require('./image/dashboard.png'),
    activity: require('./image/activity.png'),
    user: require('./image/user.png'),
    teacher: require('./image/teaching.png'),
    show: require('./image/show.png'),
    book: require('./image/book.png'),
    wallet: require('./image/wallet.png'),
    close: require('./image/close.png'),
    logout: require('./image/logout.png'),


}